import * as defaultImport from "@splunk/visualizations/Punchcard";
export * from "@splunk/visualizations/Punchcard";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
